//Pengurus
export const GET_PENGURUS_OVERVIEW = "GET_PENGURUS_OVERVIEW";
export const GET_PENGURUS_OVERVIEW_SUCCESS = "GET_PENGURUS_OVERVIEW_SUCCESS";
export const GET_PENGURUS_OVERVIEW_FAIL = "GET_PENGURUS_OVERVIEW_FAIL";

export const GET_PENGURUS_PROVINSI = "GET_PENGURUS_PROVINSI";
export const GET_PENGURUS_PROVINSI_SUCCESS = "GET_PENGURUS_PROVINSI_SUCCESS";
export const GET_PENGURUS_PROVINSI_FAIL = "GET_PENGURUS_PROVINSI_FAIL";

export const GET_PENGURUS_KABKOT = "GET_PENGURUS_KABKOT";
export const GET_PENGURUS_KABKOT_SUCCESS = "GET_PENGURUS_KABKOT_SUCCESS";
export const GET_PENGURUS_KABKOT_FAIL = "GET_PENGURUS_KABKOT_FAIL";

export const GET_PENGURUS_KECAMATAN = "GET_PENGURUS_KECAMATAN";
export const GET_PENGURUS_KECAMATAN_SUCCESS = "GET_PENGURUS_KECAMATAN_SUCCESS";
export const GET_PENGURUS_KECAMATAN_FAIL = "GET_PENGURUS_KECAMATAN_FAIL";

